import Head from "next/head";

import fetchPosts from "common/fetch/fetchPosts";
import reStructSEO, {
  parseElementList,
} from "common/source-function/reStructSEO";

import Layout from "components/common/Layout";
import Author from "components/templates/common/Author";

import dataStatic from "./data.json";

export default function Home({ data, seo }) {
  return (
    <div>
      <Head>
        {process.env.NEXT_PUBLIC_SEO == "true" ? (
          <>
            <link
              rel="alternate"
              href="https://bbcincorp.com/author/bbcincorp-content-team"
              hrefLang="en"
            />
            {/* {parser(dataStatic.seo.fullHead)} */}
            {parseElementList(seo.fullHead)}
            <meta name="robots" content="index, follow" />
          </>
        ) : (
          <meta name="robots" content="noindex, nofollow" />
        )}
        {seo?.title && <meta name="twitter:title" content={`${seo?.title}`} />}
        {seo?.description && (
          <meta name="twitter:description" content={seo?.description} />
        )}
        {seo?.opengraphUrl && (
          <meta name="twitter:url" content={seo?.opengraphUrl} />
        )}
      </Head>
      <Layout locationRouter="hk" isStaticSeo={true}>
        <Author data={dataStatic} posts={data?.posts} total={data?.total} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const hongkong = await fetchPosts({
    featuredImage: "LARGE",
    fetchAll: true,
    gqlNode: `
          databaseId
          date
          categories {
            nodes {
              name
              uri
              parent {
                node {
                  id
                }
              }
            }
          }`,
    locale: "hk",
  });

  const offshore = await fetchPosts({
    featuredImage: "LARGE",
    fetchAll: true,
    gqlNode: `
          date
          categories {
            nodes {
              name
              uri
              parent {
                node {
                  id
                }
              }
            }
          }`,
    locale: "offshore",
  });

  const singapore = await fetchPosts({
    featuredImage: "LARGE",
    fetchAll: true,
    gqlNode: `
          date
          categories {
            nodes {
              name
              uri
              parent {
                node {
                  id
                }
              }
            }
          }`,
    locale: "sg",
  });

  const vietnam = await fetchPosts({
    featuredImage: "LARGE",
    fetchAll: true,
    gqlNode: `
          date
          categories {
            nodes {
              name
              uri
              parent {
                node {
                  id
                }
              }
            }
          }`,
    locale: "vn",
  });
  const nodesHK = [];

  for (const item of hongkong.nodes) {
    if (item.databaseId !== 1267) {
      nodesHK.push({
        ...item,
        uri: `/hk${item.uri}`,
        categories: {
          nodes: item.categories.nodes.map((element) => ({
            ...element,
            uri: `/hk${element.uri}`,
          })),
        },
      });
    }
  }
  hongkong.nodes = nodesHK;
  offshore.nodes = offshore.nodes.map((item) => ({
    ...item,
    uri: `/offshore${item.uri}`,
    categories: {
      nodes: item.categories.nodes.map((element) => ({
        ...element,
        uri: `/offshore${element.uri}`,
      })),
    },
  }));
  singapore.nodes = singapore.nodes.map((item) => ({
    ...item,
    uri: `/sg${item.uri}`,
    categories: {
      nodes: item.categories.nodes.map((element) => ({
        ...element,
        uri: `/sg${element.uri}`,
      })),
    },
  }));
  vietnam.nodes = vietnam.nodes.map((item) => ({
    ...item,
    uri: `/vn${item.uri}`,
    categories: {
      nodes: item.categories.nodes.map((element) => ({
        ...element,
        uri: `/vn${element.uri}`,
      })),
    },
  }));
  const posts = [
    ...hongkong.nodes,
    ...offshore.nodes,
    ...singapore.nodes,
    ...vietnam.nodes,
  ];

  return {
    props: {
      data: {
        posts: posts || [],
        total: (posts && posts.length) || 0,
      },
      seo: reStructSEO(dataStatic.seo),
      revalidate: 1,
    },
  };
};
